import {memo, useCallback} from 'react';
import classNames from 'classnames';

const Column = ({available, current, colSpan, url, onClick}) => (
    <td className={classNames({current})} colSpan={colSpan}>
        {available && <a href={url} onClick={onClick}>&nbsp;</a>}
    </td>
);

const Wrapper = ({index, onClick, ...props}) => {
    const handleClick = useCallback(
        event => {
            event.preventDefault();
            onClick(index);
        },
        [index, onClick],
    );

    return <Column {...props} onClick={handleClick} />;
};

export default memo(Wrapper);
